// Custom events have been added to the theme to make adding
// custom functionality easier. The below events have been
// exposed as well as the associated data for each event.
// To enable this functionality update the 'useCustomEvents' variable in
// the theme.liquid file to 'true'.

// This event fires whenever an item has been added to the cart.
// This event is exposed when the ajax cart is enabled.
// The product object is passed within the detail object.
document.addEventListener("cart:item-added", function (evt) {
  console.log("Item added to the cart");
  console.log(evt.detail.product);
});

// This event fires whenever the cart is updated.
// This event is exposed when the ajax cart is enabled.
// The cart object is passed within the detail object.
document.addEventListener("cart:updated", function (evt) {
  console.log("Cart updated");
  console.log(evt.detail.cart);
});

// This event fires whenever there is an error when adding an item to the cart.
// This error is typically due to a product not having sufficient stock.
// The error message is passed within the detail object.
document.addEventListener("cart:error", function (evt) {
  console.log("Cart error");
  console.log(evt.detail.errorMessage);
});

// This event fires whenever the quick cart is opened.
// This event is exposed when the ajax cart is enabled.
// The cart object is passed within the detail object.
document.addEventListener("quick-cart:open", function (evt) {
  console.log("Quick cart opened");
  console.log(evt.detail.cart);
});

// This event fires whenever the quick cart is opened.
// This event is exposed when the ajax cart is enabled.
document.addEventListener("quick-cart:close", function () {
  console.log("Quick cart closed");
});

// This event fires whenever a variant product is selected.
// This event is exposed when a 'Variant selectors' block has been added to
// a product template or featured product section
// The selected variant object is passed within the detail object.
document.addEventListener("product:variant-change", function (evt) {
  console.log("Product variant changed");
  console.log(evt.detail.variant);
});

// This event fires whenever a product quanatiy is updated.
// This event is exposed when a 'Quantity selector' block has been added to
// a product template or featured product section
// The quantity and selected variant object is passed within the detail object.
document.addEventListener("product:quantity-update", function (evt) {
  console.log("Product quantity updated");
  console.log(evt.detail.quantity, evt.detail.variant);
});

// This event fires whenever quickview modal is opened.
// This event is exposed when the 'Enable quick view' feature is enabled
// And a quick view modal is opened.
document.addEventListener("quickview:loaded", function () {
  console.log("Quickview loaded");
});

  const fixYotpoAlignment = () => {
    document.querySelectorAll(
      '#shopify-section-template--25044745814401__featured_collection_grid_zrLCKA .yotpo-reviews-star-ratings-widget'
    ).forEach(el => {
      el.style.justifyContent = 'center';
    });
  };

  fixYotpoAlignment();
  const observer = new MutationObserver(fixYotpoAlignment);
  observer.observe(document.body, { childList: true, subtree: true });

//Quiz Javascript

var CartRefesh = new CustomEvent('apps:product-added-to-cart');
var CartOpen = new CustomEvent('confirmation-popup:open');

document.addEventListener('octane.quiz.addToCart', function (e) {
    // your code for successfully added items
    console.log(e.detail); // example: {items: [{id: '12345', quantity: 1}]}

    document.dispatchEvent(CartRefesh);
    document.dispatchEvent(CartOpen);
}, false);

document.addEventListener('octane.quiz.addToCartError', function (e) {
    // your code for the error case
}, false);


//Quiz Completion Script

const eventNames = [
    "octane.quiz.completed",
    "octane.quiz.accessed"
];

eventNames.forEach(event => {
    document.addEventListener(event, e => {
        console.log(e.detail);

        // Hero product classes
        const firstTopContentSelector = document.querySelector(".oct-quiz-title");
        const firstProductTitleSelector = document.querySelector(".oct-quiz-result-item__title");
        const firstProductDescription = document.querySelector(".oct-quiz-result-item__description");
        const heroProductBlockSelector = document.querySelector(".oct-quiz-products");
        const heroProductImageSelector = document.querySelector(".oct-quiz-result-item__img");
        const heroProductCopyWrapper = document.querySelector(".oct-quiz-result-item__copy-wrapper");


        firstProductTitleSelector.classList.add("oct-quiz-result-first-item__title");
        firstProductDescription.classList.add("oct-quiz-result-first-item__description");
        heroProductBlockSelector.classList.add("oct-quiz-hero-product");
        heroProductImageSelector.classList.add("oct-quiz-result-item__hero-img");
        heroProductCopyWrapper.classList.add("oct-quiz-result-item__hero-copy-wrapper");


        // Code for dynamically inserting Yotpo review widget.
        const productTitles = document.querySelectorAll(".oct-quiz-result-item__title");
        const productTypeTitles = document.querySelectorAll(".oct-quiz-result-item__img-wrapper");
        const productDescs = document.querySelectorAll(".oct-quiz-result-item__description");
        const productPrices = document.querySelectorAll(".oct-quiz-result-item__pricing");
        const productIdArray = [];
        const productdescArray = [];
        const producttypeArray = [];
        const productpriceArray = [];
        const productURLArray = [];
        const productURLIDArray = [];
        const productShortDesc = [];

        function buildProductIdArray() {
            if (!e.detail.product_blocks[0].length) {
                console.log("Array 0 is empty");

                e.detail.product_blocks[1].forEach(productBlock => {
                    productIdArray.push(productBlock.id);
                });
                e.detail.product_blocks[1].forEach(productBlock => {
                    productdescArray.push(productBlock.description);
                });
                //push URL
                e.detail.product_blocks[1].forEach(productBlock =>{                
                let url = /https:\/\/lovenoughty\.co\.uk\//i;
                var def = [productBlock.link.replace(url,'')]
                productURLArray.push({'url':def});
                })
                //END URL PUSH
                e.detail.product_blocks[1].forEach(productBlock => {
                    producttypeArray.push(productBlock.type);
                });
                e.detail.product_blocks[1].forEach(productBlock => {
                    productpriceArray.push(productBlock.price_formatted);
                });
                console.log(productIdArray);
                console.log(productdescArray);
                console.log(producttypeArray);
                console.log(productpriceArray);
            } else {
                productIdArray.push(e.detail.product_blocks[0][0].id);
                e.detail.product_blocks[1].forEach(productBlock => {
                    productIdArray.push(productBlock.id);
                });
                productdescArray.push(e.detail.product_blocks[0][0].description);
                e.detail.product_blocks[1].forEach(productBlock => {
                    productdescArray.push(productBlock.description);
                });
                //push URL
                let cleanurl = /https:\/\/lovenoughty\.co\.uk\//i;
                var bundleurl = e.detail.product_blocks[0][0].link.replace(cleanurl,'')
                productURLArray.push({'url':bundleurl});
                e.detail.product_blocks[1].forEach(productBlock =>{                
                let url = /https:\/\/lovenoughty\.co\.uk\//i;
                var def = [productBlock.link.replace(url,'')]
                productURLArray.push({'url':def});
                })
                //END URL PUSH
                producttypeArray.push(e.detail.product_blocks[0][0].type);
                e.detail.product_blocks[1].forEach(productBlock => {
                    producttypeArray.push(productBlock.type);
                });
                productpriceArray.push(e.detail.product_blocks[0][0].price_formatted);
                e.detail.product_blocks[1].forEach(productBlock => {
                    productpriceArray.push(productBlock.price_formatted);
                });
                console.log(productIdArray);
                console.log(productdescArray);
                console.log(producttypeArray);
                console.log(productpriceArray);
                console.log(productURLArray);
            }
        }
        buildProductIdArray();




        productDescs.forEach((productDesc, i) => {
          var SDesc = "";
          fetch(window.Shopify.routes.root + productURLArray[i].url + '?view=metafields')
          .then(response => response.json())
          .then(data => { productDesc.innerHTML = '<div id="oct-Quiz-Disc-Holder">'+ data.product_intro + '</div>' });
          
          //productDesc.innerHTML = '<div id="oct-Quiz-Disc-Holder"> '+ SDesc + '</div>';
          }); 
          
  

        productTitles.forEach((productTitle, i) => {
            productTitle.innerHTML += `
<div class="quiz-Yotpo-Container">
    <div class="yotpo-widget-instance" data-yotpo-instance-id="207026" data-yotpo-product-id="${productIdArray[i]}" data-yotpo-cart-product-id="${productIdArray[i]}" data-yotpo-section-id="collection"></div>
</div>
`
            if (i === 0 && e.detail.product_blocks[0].length) {
                productTitle.innerHTML += `
<div id="quizBundlePrice" style="display: inline !important;"></div>
`
            } else {
                productTitle.innerHTML += `
<div id="quizPrice" style="color:#102B26;display:inline;font-family: GothamMedium;font-size:14.6552px;font-style:normal;font-weight:400;height:auto;letter-spacing:normal;line-height:21.9829px;text-align:center;visibility:visible;width:auto; margin-bottom:10px; padding-bottom:10px;">${productpriceArray[i]}</div>
`
            }
        });

        productPrices.forEach((productPrice, i) => {
            if (!e.detail.product_blocks[0].length) {
                productPrice.setAttribute("style", "display:none !Important;text-align: center;");
            } else {
                // Declare a fragment:
                var fragment = document.createDocumentFragment();

                // Append desired element to the fragment:
                fragment.appendChild(productPrice);

                // Append fragment to desired element:
                document.getElementById('quizBundlePrice').appendChild(fragment);
                if (i === 0) {
                    productPrice.setAttribute("style", "font-size:16px !Important;text-align: center;");
                }
                if (i > 0) {
                    productPrice.setAttribute("style", "display:none !Important;text-align: center;");
                }
            }
        });



        // Add Product Type Ahead of the Image.
        productTypeTitles.forEach((productTypeTitle, i) => {
            if (e.detail.product_blocks[0].length) {
                if (i === 0) return;
                if (i === 1) {

                    productTypeTitle.insertAdjacentHTML("beforeBegin", `
<div class="oct-quiz-products__header_step">Shampoo</div>
`);
                }
                if (i === 2) {

                    productTypeTitle.insertAdjacentHTML("beforeBegin", `
<div class="oct-quiz-products__header_step">Conditioner</div>
`);
                }
                if (i === 3) {

                    productTypeTitle.insertAdjacentHTML("beforeBegin", `
<div class="oct-quiz-products__header_step">Treatment</div>
`)
                }
                if (i === 4) {

                    productTypeTitle.insertAdjacentHTML("beforeBegin", `
<div class="oct-quiz-products__header_step">Styling</div>
`)
                }
                productTypeTitle.insertAdjacentHTML("beforeBegin", `
<div class="oct-quiz-products__header_step">
    <h2></h2>
</div>
`);
            } else {
                if (i === 0) {

                    productTypeTitle.insertAdjacentHTML("beforeBegin", `
<div class="oct-quiz-products__header_step">Shampoo</div>
`);
                }
                if (i === 1) {

                    productTypeTitle.insertAdjacentHTML("beforeBegin", `
<div class="oct-quiz-products__header_step">Conditioner</div>
`);
                }
                if (i === 2) {

                    productTypeTitle.insertAdjacentHTML("beforeBegin", `
<div class="oct-quiz-products__header_step">Treatment</div>
`);
                }
                if (i === 3) {

                    productTypeTitle.insertAdjacentHTML("beforeBegin", `
<div class="oct-quiz-products__header_step">Styling</div>
`);
                }
                productTypeTitle.insertAdjacentHTML("beforeBegin", `
<div class="oct-quiz-products__header_step">
    <h2></h2>
</div>
`);
            }
        });


        // initialise the Yotpo AJAX scripts to load the star ratings
        yotpoWidgetsContainer.initWidgets();


        // Code for hiding compare at price if it's £0.00
        const compareAtPriceCollection = document.getElementsByTagName("s");
        for (let price of compareAtPriceCollection) {
            if (price.innerHTML === "£0.00") {
                price.style.display = "none";
            }
        }


        // Insert dynamic answer data
        const quizTextureAnswer = e.detail.answers["Octane: Quiz-Texture"];
        const quizTypeAnswer = e.detail.answers["Octane: Quiz-Type"];
        const quizConcernAnswer = e.detail.answers["Octane: Quiz-Concern"];
        const quizEmailConsent = e.detail.email_consent;
        const quizContentName = e.detail.answers["first_name"];
        const quizContentNameStr = quizContentName.charAt(0).toUpperCase() + quizContentName.slice(1);
        const email_Consent = e.detail.email_consent;
        const email_Adr = e.detail.email;

        //console.log(email_Consent);
        //console.log(email_Adr);


        function quizName() {
            if (quizContentName === "") {
                return "Y";
            } else {
                return quizContentNameStr + ", y";

            }
        }


        // Replace the results page title with dynamic content - placeholder title must be in in place for this to work.
        firstTopContentSelector.innerHTML = `
<div class="oct-quiz-heading-top">HAIR &amp; SCALP <span style="color:#FE47B7 !Important">QUIZ</span></div>
<div class="oct-quiz-subheading">${quizName()}our profile is...</div>
<div class="quiz-answer-summary-container">
    <div class="quiz-answer-summary-block">
        <p class="quiz-dynamic-answer-label">HAIR TEXTURE:</p>
        <p class="quiz-dynamic-answer">${(quizTextureAnswer.charAt(0) + quizTextureAnswer.slice(1).toLowerCase())}</p>
    </div>
    <div class="quiz-answer-summary-block">
        <p class="quiz-dynamic-answer-label">HAIR TYPE:</p>
        <p class="quiz-dynamic-answer">${quizTypeAnswer.charAt(0) + quizTypeAnswer.slice(1).toLowerCase()}</p>
    </div>
    <div class="quiz-answer-summary-block">
        <p class="quiz-dynamic-answer-label">SCALP CONCERN:</p>
        <p class="quiz-dynamic-answer">${quizConcernAnswer.charAt(0) + quizConcernAnswer.slice(1).toLowerCase()}</p>
    </div>
</div>
<p></p>
<div class="oct-quiz-Desc">
    <h2>Personalised routine</h2>
    <p>Restore your hair's natural beauty and health by following the routine below</p>
</div>
`;

        //Code to add the discount message
        if (email_Consent === true) {
            document.querySelector(".oct-quiz-btn-wrapper-buy-all").insertAdjacentHTML("afterend", `
<div class="oct-Quiz-Disc-Holder">
    <!--<h2>Discount Sign Up</h2>-->
    <p>Your exclusive 15% off* discount code is making it's way to your inbox, the email you provided was ${email_Adr}</p>
    <br />
</div>
`);
        }




        // Code for inserting combined price of 2nd product block above add all to cart button.


        function addAllToBagCombinedPrice() {
            let combinedPrice = 0;


            const priceArray = e.detail.product_blocks[1].map(productObj => {
                return Number(productObj.price_formatted.replace(/[^0-9.-]+/g, ""));
            });


            //console.log(priceArray);


            priceArray.forEach(price => {
                combinedPrice = combinedPrice + price;
                //console.log(combinedPrice);
            });


            document.querySelector(".oct-quiz-btn-wrapper-buy-all").insertAdjacentHTML(
                "afterbegin",
                `<div class="oct-quiz-result-item__combined-pricing-heading">Get all the below products with one click...</div>
<div class="oct-quiz-result-item__combined-pricing">
    £${combinedPrice}
</div>`
            );
        }
        addAllToBagCombinedPrice();
    }, false);

});
